import {
  DynamicAttributeFieldSimpleMetaFragment,
  DynamicAttributeType,
} from "gql/graphql";
import { DynamicAttributeFieldSimpleBoolean } from "./dynamic-attribute-field-simple-boolean";
import { DynamicAttributeFieldSimpleDate } from "./dynamic-attribute-field-simple-date";
import { DynamicAttributeFieldSimpleDatetime } from "./dynamic-attribute-field-simple-datetime";
import { DynamicAttributeFieldSimpleNumber } from "./dynamic-attribute-field-simple-number";
import { DynamicAttributeFieldSimpleString } from "./dynamic-attribute-field-simple-string";
import { AnyInput } from "../dynamic-attribute-field-input-types";

type DynamicAttributeFieldSimpleProps = AnyInput<{
  meta: DynamicAttributeFieldSimpleMetaFragment;
}>;

export function DynamicAttributeFieldSimple({
  meta,
  ...rest
}: DynamicAttributeFieldSimpleProps) {
  switch (meta.type) {
    case DynamicAttributeType.Boolean:
      return <DynamicAttributeFieldSimpleBoolean meta={meta} {...rest} />;
    case DynamicAttributeType.Date:
      return <DynamicAttributeFieldSimpleDate {...rest} />;
    case DynamicAttributeType.DateTime:
      return <DynamicAttributeFieldSimpleDatetime {...rest} />;
    case DynamicAttributeType.Number:
      return <DynamicAttributeFieldSimpleNumber {...rest} />;
    case DynamicAttributeType.Float:
      return <DynamicAttributeFieldSimpleNumber {...rest} />;
    case DynamicAttributeType.String:
      return <DynamicAttributeFieldSimpleString {...rest} />;
    default:
      throw new Error(`Unknown dynamic attribute type ${meta.type}`);
  }
}
